import React from 'react';
import {X} from 'polyphony/icons';
import {scrolling} from 'polyphony/dom';
import {useHotkeys, useUnique} from 'polyphony/hooks';

const styles = {
    fullscreenDiv: {
        zIndex: 100,
        position: "fixed",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        justifyContent: "center",
        alignItems: "center"
    },
    contentWrapper: {
        pointerEvents: 'auto',
        position: "relative",
        display: "grid",
        width: "auto",
        height: "auto",
        zIndex: 100000,
        margin: 22
    },
    innerStyle: {
        gridColumn: 1,
        gridRow: 1,
        boxSizing: 'border-box',
        width: "100%",
        height: "100%",
        maxWidth: 700,
        maxHeight: "70vh",
        pointerEvents: 'auto',
        borderRadius: 6,
        overflow: 'hidden'
    },
    innerStyleEditor: {
        overflow: 'auto',
        minWidth: '33vw'
    },
    x: {
        width: 44,
        height: 44,
        background: "black",
        color: "white",
        top: -22,
        right: -22,
        position: 'absolute',
        borderRadius: 22,
        userSelect: 'none',
        cursor: 'pointer',
        pointerEvents: 'all',
        zIndex: 100000,
        boxSizing: 'border-box',
        padding: 5
    }
};

const Modal = ({children, opener, onOpen, onClose, openerWrapperStyle, isEditor, initiallyOpen}) => {
    const [isOpen, setOpen] = React.useState(initiallyOpen);

    const close = () => {
        if (!isOpen) return true;
        setOpen(false);
        scrolling.enable();
        if (onClose) onClose();
        return false;
    };

    const open = () => {
        if (isOpen) return true;
        setOpen(true);
        scrolling.disable();
        if (onOpen) onOpen();
        return false;
    };

    const contentWrapperOnClick = e => {
        if (isEditor || e.target.className !== 'x') {
            e.stopPropagation();
        }
    };

    const ref = useHotkeys({
        Escape: close
    }, []);

    React.useEffect(() => {
        if (isOpen) {
            ref.current.focus();
        }
    }, [isOpen]);

    const id = useUnique();

    // TODO: aria-live (requires wrapper div)
    return (
        <>
            <div onClick={open}
                 style={{cursor: 'pointer', ...openerWrapperStyle}}
                 role="button"
                 aria-controls={id}>
                {opener}
            </div>
            <div className='polyphony-modal'
                 onClick={close}
                 ref={ref}
                 role='dialog'
                 aria-modal='true'
                 id={id}
                 style={{...styles.fullscreenDiv,
                         display: isOpen ? 'flex' : 'none',
                         background: isEditor ? 'transparent':  "hsla(0, 0%, 0%, 0.6)"
                         }}>
                <div role="none" style={styles.contentWrapper} onClick={contentWrapperOnClick}>
                    <X style={styles.x} onClick={close} />
                    <div role="none" className='polyphony-modal-inner-content' style={{...styles.innerStyle, ...isEditor ? styles.innerStyleEditor : {}}}>
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};

Modal.displayName = 'Modal';

export default Modal;

